import React, { ReactElement } from "react";
import { GradeCellProps } from "../../types/GradeCellProps";
import { GradeLozenge } from "../../GradeLozenge/GradeLozenge";
import "./GradeCell.css";

export const GradeCell = (props: GradeCellProps): ReactElement => {
    return (
        <div className="grade-cell flex justify-content-between align-items-center">
            <span className="p-accordion-header-text">{props.name}</span>
            <div className="pl-3">
                <GradeLozenge grade={props.score}></GradeLozenge>
            </div>
        </div>
    );
};
